import { MERCHANT_GROUP_API_PATH } from "src/confs/APIConfig";
import MerchantGroup from "src/merchantgroups/objects/MerchantGroup";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import {
  APIGetAxios,
  APIPostAxios,
  APIPutAxios,
  TEMP_AXIOS_NEW_ERROR_CODE_HANDLING,
} from "src/shared/actions/FetchActions";
import type AuthenticationToken from "src/authentication/objects/AuthenticationToken";
import { removeEmptyStringsFromObj } from "src/shared/helpers/removeEmptyStringsFromObj";

export function GetMerchantGroups(authenticationToken?: AuthenticationToken) {
  return async (dispatch: ThunkDispatchType) => {
    const fetchResult = await dispatch(
      APIGetAxios<MerchantGroup[]>(
        `${MERCHANT_GROUP_API_PATH}`,
        undefined,
        authenticationToken,
        TEMP_AXIOS_NEW_ERROR_CODE_HANDLING,
      ),
    );
    return fetchResult.data.map((merchantGroupJson: any) => {
      return new MerchantGroup(merchantGroupJson);
    });
  };
}

export function GetMerchantGroupByMerchantGroupUUID(merchantGroupUUID: string) {
  return async (dispatch: ThunkDispatchType) => {
    const fetchResult = await dispatch(
      APIGetAxios<MerchantGroup>(
        `${MERCHANT_GROUP_API_PATH}/${merchantGroupUUID}`,
        undefined,
        undefined,
        TEMP_AXIOS_NEW_ERROR_CODE_HANDLING,
      ),
    );
    return new MerchantGroup(fetchResult.data);
  };
}

export function CreateMerchantGroup(merchantGroup: MerchantGroup) {
  return async (dispatch: ThunkDispatchType) => {
    const fetchResult = await dispatch(
      APIPostAxios<{ merchantGroupUUID: string }>(
        `${MERCHANT_GROUP_API_PATH}`,
        JSON.stringify(merchantGroup.toJSON()),
        undefined,
        undefined,
        TEMP_AXIOS_NEW_ERROR_CODE_HANDLING,
      ),
    );
    return fetchResult.data.merchantGroupUUID;
  };
}

export function EditMerchantGroup(merchantGroup: MerchantGroup) {
  return async (dispatch: ThunkDispatchType) => {
    const jsonObj = merchantGroup.toJSON();
    removeEmptyStringsFromObj(jsonObj);
    const fetchResult = await dispatch(
      APIPutAxios<{}>(
        `${MERCHANT_GROUP_API_PATH}/${merchantGroup.merchantGroupUUID}`,
        jsonObj,
        undefined,
        undefined,
        TEMP_AXIOS_NEW_ERROR_CODE_HANDLING,
      ),
    );
    return fetchResult.data;
  };
}
